import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';

export class FavoriteApiService {
  private readonly favoriteBaseUrl: string;

  constructor() {
    this.favoriteBaseUrl = ApiConstants().favorite;
  }

  async getFavoritesByUserIdAndThemeId(
    userId: string,
    themeId: string,
  ): Promise<AxiosResponse> {
    const response = await request({
      method: 'GET',
      url: `${this.favoriteBaseUrl}user-theme?userId=${userId}&themeId=${themeId}`,
      requiresToken: true,
    });

    return response;
  }

  async addFavorite(
    userId: string,
    resourceId: string,
  ): Promise<AxiosResponse> {
    const response = await request({
      method: 'POST',
      url: this.favoriteBaseUrl,
      data: { _userId: userId, _resourceId: resourceId },
      headers: { 'Content-Type': 'application/json' },
      requiresToken: true,
    });
    return response;
  }

  async removeFavorite(favoriteId: string): Promise<AxiosResponse> {
    const response = await request({
      method: 'DELETE',
      url: `${this.favoriteBaseUrl}${favoriteId}`,
      requiresToken: true,
    });
    return response;
  }
}
